import React from "react";
import { practices } from "../data/content";

function Services() {
  return (
    <section id="services" className="section">
      <div className="container">
        <div className="section-head" data-reveal>
          <p className="eyebrow">What we do</p>
          <h2 className="section-title">Two practices. One accountable partner.</h2>
          <p className="section-lead">
            From the first data point to the finished application, our teams cover the full lifecycle —
            so your data and your software are designed to work together.
          </p>
        </div>

        {practices.map((p) => (
          <div className={`practice practice-${p.id}`} key={p.id} data-reveal>
            <div className="practice-intro">
              <span className="practice-code">{p.code}</span>
              <h3 className="practice-title">{p.title}</h3>
              <p className="practice-summary">{p.summary}</p>
              <a href="#contact" className="text-link">
                Discuss a {p.id === "data" ? "data" : "development"} project{" "}
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </a>
            </div>
            <div className="practice-grid">
              {p.services.map((s) => (
                <article className="service-tile" key={s.title}>
                  <span className="service-icon">
                    <i className={`fa-solid ${s.icon}`} aria-hidden="true" />
                  </span>
                  <h4>{s.title}</h4>
                  <p>{s.text}</p>
                </article>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;
